var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, observable } from "mobx";
export class DatesModel {
    constructor(data) {
        this.id = data.id;
        this.from = data.from;
        this.timeRange = data.timeRange;
        this.dayOfWeek = data.dayOfWeek;
        this.formattedDate = data.formattedDate;
        this.order = data.order;
        this.type = "dates";
    }
    update(newItem) {
        newItem.id && (this.id = newItem.id);
        newItem.order && (this.order = newItem.order);
        this.updateTimeProps(newItem);
    }
    updateTimeProps(newItem) {
        newItem.from && (this.from = newItem.from);
        newItem.timeRange && (this.timeRange = newItem.timeRange);
        newItem.dayOfWeek && (this.dayOfWeek = newItem.dayOfWeek);
        newItem.formattedDate && (this.formattedDate = newItem.formattedDate);
    }
}
__decorate([
    observable,
    __metadata("design:type", Date)
], DatesModel.prototype, "from", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DatesModel.prototype, "update", null);
//# sourceMappingURL=DatesModel.js.map